import { NotificationListItemTaskFragment } from "@/__generated__/graphql";
import Text from "@/shared/typography/text";
import { Title } from "@/modules/common/widgets/notification-bell/ui/title";
import { usePalette } from "@/shared/theme";
import { CSSProperties } from "react";
import Tag from "@/shared/data-display/tag";
import { SyncOutlined } from "@ant-design/icons";
import { useTranslations } from "use-intl";
import { LinkForTitle } from "@/modules/common/widgets/notification-bell/ui/link-for-title";
import { generatePath } from "react-router-dom";
import { TASK_PATH } from "@/modules/tasks/pages/task";
import { isTaskDone, Task } from "@/modules/tasks/entities/task";

export function NotificationListItemTask({
  task,
}: {
  task: NotificationListItemTaskFragment;
}) {
  const palette = usePalette();
  const t = useTranslations("NotificationBell");

  return (
    <div>
      <div>
        <LinkForTitle to={generatePath(TASK_PATH, { id: task.id })}>
          <Title>
            <Task.Name data={task} />
          </Title>
        </LinkForTitle>
      </div>
      <div className={"mt-3"}>
        <ul
          className={"list-disc list-inside !text-[--color]"}
          style={{ "--color": palette.neutral[7] } as CSSProperties}
        >
          <li>
            <Text
              as={"span"}
              type={"body3"}
              className={"!text-[--color]"}
              style={{ "--color": palette.neutral[7] } as CSSProperties}
            >
              {t("Priority")}: <Task.Priority data={task} />
            </Text>
          </li>
          <li>
            <Text
              as={"span"}
              type={"body3"}
              className={"!text-[--color]"}
              style={{ "--color": palette.neutral[7] } as CSSProperties}
            >
              {t("Due date")}: <Task.DueDate data={task} />
            </Text>
          </li>
          <li>
            <Text
              as={"span"}
              type={"body3"}
              className={"!text-[--color]"}
              style={{ "--color": palette.neutral[7] } as CSSProperties}
            >
              {t("Created")}: <Task.CreatedAgo data={task} />
            </Text>
          </li>
        </ul>
      </div>
      {!isTaskDone(task) && (
        <div className={"flex justify-end"}>
          <Tag
            icon={<SyncOutlined />}
            className={"!bg-transparent border-[--color] !text-[--color]"}
            style={{ "--color": palette.primary[5] } as CSSProperties}
          >
            {t("In progress")}
          </Tag>
        </div>
      )}
    </div>
  );
}
